export const EOB_ONBOARDING_STORAGE_KEY = 'eob-onboarding-storage'
